import React from "react";
import InquiryToCustomer from "@/src/types/Entities/InquiryToCustomer";
import HintBox from "@/src/components/Box/HintBox/HintBox";
import { Stack, Typography } from "@mui/material";
import { translate } from "@/src/services/translations/translations";
import dayjs from "dayjs";

type InquiryToCustomerOverviewBoxProps = {
  inquiryToCustomer: InquiryToCustomer;
};

export default function InquiryToCustomerOverviewBox({ inquiryToCustomer }: InquiryToCustomerOverviewBoxProps) {
  if (inquiryToCustomer.inquiryType === "appointment") {
    return (
      <HintBox headline={"Termin vereinbaren"}>
        <Stack>
          <Typography>
            In Ihrem Fall ist eine telefonische Rücksprache nötig. Bitte vereinbaren Sie sich einen Beratungstermin{" "}
            <strong>bis zum {dayjs(inquiryToCustomer.deadline).format("DD.MM.YYYY")}</strong>, damit Ihr Fall weiter bearbeitet werden kann.
          </Typography>
        </Stack>
      </HintBox>
    );
  }

  return (
    <HintBox headline={"Ihre Rückmeldung wird benötigt"}>
      <Typography>
        Es werden {translate("inquiryToCustomer.inquiryType.options." + inquiryToCustomer.inquiryType + ".label", {})} von Ihnen benötigt. Bitte stellen Sie
        diese <strong>bis zum {dayjs(inquiryToCustomer.deadline).format("DD.MM.YYYY")}</strong> zur Verfügung, damit Ihr Fall weiter bearbeitet werden kann.
      </Typography>
    </HintBox>
  );
}
